import { createContext } from 'react'
import type { TimelineItem } from '../types/timeline'

export interface CanvasScaleContextValue {
  viewWindowStart: Date
  viewWindowEnd: Date
  focusedItemId: string | null
  minWindowMs: number
  absoluteStart: Date
  absoluteEnd: Date
  setFocusedItemId: (itemId: string | null) => void
  setViewWindow: (startDate: Date, endDate: Date) => void
  zoomAt: (anchorRatio: number, zoomFactor: number) => void
  panByRatio: (ratioDelta: number) => void
  focusItem: (itemId: string, item: TimelineItem) => void
  resetViewWindow: () => void
}

export const CanvasScaleContext = createContext<CanvasScaleContextValue | undefined>(undefined)
